!function (n) {
  n.languages.ignore = {
    comment: /^#.*/m,
    entry: {
      pattern: /\S(?:.*(?:(?:\\ )|\S))?/,
      alias: "string",
      inside: {
        operator: /^!|\*\*?|\?/,
        regex: {
          pattern: /(^|[^\\])\[[^\[\]]*\]/,
          lookbehind: !0
        },
        punctuation: /\//
      }
    }
  }, n.languages.gitignore = n.languages.ignore, n.languages.hgignore = n.languages.ignore, n.languages.npmignore = n.languages.ignore;
}(Prism);